export default __webpack_public_path__ + "static/sz_hu_5-16309e84df43cbb7bbc79342e68aba6f.mp4";